export default __webpack_public_path__ + "static/media/rocket.b1603ebb.svg";